export default __webpack_public_path__ + "static/media/astronaut-visor.5fbad969.jpg";